import Component from "../../component";
import {getTrottledFunction} from "../../helpers/throttle";

export const OrientatorConfig = {
    signature: 'Orientator',
    baseHtmlClass: 'orientator',
    selector: '.orientator',

    datasetConfigKey: 'orientator__config',

    landscapeOrientation: 'landscape',
    portraitOrientation: 'portrait',
    squareOrientation: 'square',
    orientations: ['landscape', 'portrait', 'square'],

    squareMargin: 0.0,
};


export class Orientator extends Component {

    static applyToAll() {
        document.querySelectorAll(Orientator.config.selector).forEach((element) => {
            if (!Orientator.isElementComponentized(element, Orientator.config.signature)) new Orientator(element);
        });
    }

    static get config() {
        return OrientatorConfig;
    }

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: Orientator.config
        });

        this.setDatasetConfig(Orientator.config.datasetConfigKey);

        this.classForApply = this.getDatasetConfigValue('class_for_apply') ?? Orientator.config.baseHtmlClass;
        this.squareMargin = this.getDatasetConfigValue('square_margin') ?? this.config.squareMargin;

        this.orientation = this.getOrientation();

        const resizeHandler = getTrottledFunction(this.handleResize.bind(this), 10);
        this.observer = new ResizeObserver(resizeHandler);
        this.observer.observe(this.element);

        this.render();
    }

    render() {
        this.config.orientations.forEach(orientation => {
            const modifier = orientation;
            if (this.orientation === orientation) {
                this.element.classList.add(`${this.classForApply}--${modifier}`);
            } else {
                this.element.classList.remove(`${this.classForApply}--${modifier}`);
            }
            this.conditionallySetHtmlClassState(this.orientation === orientation, orientation);
        });
    }

    handleResize() {
        const newOrientation = this.getOrientation();
        if (newOrientation === this.orientation) return;
        this.orientation = newOrientation;
        this.render();
    }

    getOrientation() {
        if (this.isSquarish()) return Orientator.config.squareOrientation;
        return this.getWidth() > this.getHeight() ? Orientator.config.landscapeOrientation : Orientator.config.portraitOrientation;
    }

    // A function that determines if the element is square in aspect ratio.
    // It is square if it falls within the square margin percentage.
    isSquarish() {
        const aspect = this.getAspect();
        const squareMargin = this.squareMargin;
        const squareMarginMin = 1.0 - squareMargin;
        const squareMarginMax = 1.0 + squareMargin;
        return aspect >= squareMarginMin && aspect <= squareMarginMax;
    }

    getWidth() {
        return this.element.offsetWidth;
    }

    getHeight() {
        return this.element.offsetHeight;
    }
    
    getAspect() {
        const width = this.getWidth();
        const height = this.getHeight();
        return parseFloat(width) / parseFloat(height);
    }
}
